var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Cva component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCva extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon-cva', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.9615 4.98102C18.5926 4.77782 17.3734 4.37411 16.2773 3.78056C15.1784 3.18435 14.1999 2.3983 13.3229 1.40906C13.2053 1.27806 13.0609 1.17111 12.9032 1.10427C12.7481 1.03476 12.5796 1 12.4139 1C12.2481 1 12.0797 1.03476 11.9246 1.10427C11.7695 1.17379 11.6225 1.27806 11.5049 1.40906C10.6279 2.3983 9.64936 3.18435 8.5505 3.78056C7.45164 4.37411 6.23515 4.7805 4.86625 4.98102L4 5.10935V8.74815C4.07219 11.4271 4.59622 13.6462 5.35018 15.4616C6.48379 18.186 8.13609 19.9827 9.51033 21.0869C10.8846 22.1938 11.9808 22.6216 12.0503 22.651L12.4139 22.79L12.7775 22.651C12.8737 22.6135 14.7907 21.8649 16.7558 19.7447C17.7371 18.686 18.7236 17.2797 19.4776 15.4643C20.2315 13.6489 20.7556 11.4298 20.8278 8.75082V5.10935L19.9615 4.98102ZM12.4112 11.7907C12.4112 11.903 12.3203 11.9939 12.208 11.9939H6.39556C6.18969 11.002 6.05601 9.91385 6.02393 8.70537V6.82849C8.49435 6.30714 10.6359 5.15748 12.4112 3.39289V11.7907ZM12.4112 20.5923V11.9939H18.4269C17.2371 17.7288 13.5903 19.9987 12.4112 20.5923Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconCva.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCva.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconCva.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconCva.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-cva') === undefined) {
    customElements.define('cat-icon-cva', BlocksIconCva);
}
